import axios from 'axios';
import mockData from '../../mocks/analyticsData';
import { baseURL } from './api';

const apiVersion = 'v2';
const path = process.env.REACT_APP_BASE_URL + '/api/';

class AnalyticsService {
  static baseURL = baseURL;

  static resourcePath = path || '';

  constructor(api, demo = false, baseURLOverride) {
    this.api = api;
    this.demo = demo;
    this.baseURL = baseURLOverride;
  }

  getBaseURL = () => {
    return this.baseURL || AnalyticsService.resourcePath || AnalyticsService.baseURL;
  };

  getPaginateOptions = options => {
    return JSON.stringify(options || { page: 1, limit: 10 });
  };

  async getAnalyticsReport() {
    return mockData;
  };

}

export default AnalyticsService;
